module.exports = __webpack_public_path__ + "img/only-shadow.88959c78.svg";